export default {
  title: 'Odhlášení e-mailů',
  heading: 'Odhlášení e-mailových notifikací',
  isLoading: 'Načítáme informace o odběru…',

  type: {
    change: 'okamžitá upozornění na zjištěné změny v rejstřících',
    report: 'pravidelný měsíční report monitoringu',
    deadline: 'upozornění na blížící se termíny (Hlídač termínů)',
  },

  confirm: {
    text: 'Chcete se odhlásit z odběru e-mailů „{{typeLabel}}“ pro dům {{svjName}}?',
    note: 'Odhlášení platí jen pro vaši e-mailovou adresu. Ostatním správcům domu budou e-maily chodit dál.',
    action: 'Odhlásit odběr',
  },

  unsubscribed: {
    text: 'Odběr e-mailů „{{typeLabel}}“ pro dům {{svjName}} je odhlášený.',
    note: 'Kdykoli si ho můžete znovu zapnout zde, nebo přímo v aplikaci v nastavení daného modulu.',
    action: 'Znovu přihlásit odběr',
  },

  resubscribed: {
    text: 'Odběr e-mailů „{{typeLabel}}“ pro dům {{svjName}} je znovu zapnutý.',
  },

  invalidLink: {
    text: 'Odkaz není platný. Zkuste jej prosím z e-mailu zkopírovat celý, nebo si notifikace nastavte přímo v aplikaci v nastavení daného modulu.',
  },

  error: 'Něco se nepovedlo. Zkuste to prosím znovu.',
  toApp: 'Přejít do aplikace',
};
